/**
 * Champions Dashboard - Feature Demos Page
 * Lake Charles Landing Page - Modern Migration
 *
 * Route: /champions/dashboard/demos
 */
import React from 'react';
import { ChampionsDashboardLayout } from '../../components/champions/dashboard/ChampionsDashboardLayout';
import { FeatureDemos } from '../../components/champions/dashboard/FeatureDemos';

export function ChampionsDemosPage() {
  // TODO: Replace with actual Champion data from backend/store
  const championName = 'Sarah Johnson';
  const championNumber = 3;

  return (
    <ChampionsDashboardLayout championName={championName} championNumber={championNumber}>
      <FeatureDemos />
    </ChampionsDashboardLayout>
  );
}

export default ChampionsDemosPage;
